// import ModalCaptcha from '@pages/Home/components/ModalCaptcha'
import Search from '@pages/Payment/Components/Search'
import * as Sentry from '@sentry/browser'
import { API_URL, NetWorkService, validResponse } from '@utils/API'
import { CODE_SUCCESS } from '@utils/constan'
import { detectEnvUat } from '@utils/general'
import { message } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { RootState } from 'store'
import { setEduBillDetail, setLoading, setStudenInfor, Type_Initstate } from 'store/appSlice'
import { ItemBillResponse } from '../../types/general'
import TableHistory from './Components/TableHistory'

const dataIntroduce = [
  {
    title: 'Thuận tiện',
    img: require('@assets/icon/thuantien.png'),
    desc: 'Cổng thanh toán trực tuyến tạo sự thuận tiện cho người học trong quá trình thanh toán học phí và các khoản phải nộp khác thông qua hệ thống thanh toán trực tuyến',
  },
  {
    title: 'Linh hoạt',
    img: require('@assets/icon/tienloi.png'),
    desc: 'Phụ huynh, người thân có thể nộp học phí thay cho người học một cách dễ dàng, tiện lợi',
  },
  {
    title: 'Nhanh chóng',
    img: require('@assets/icon/nhanhchong.png'),
    desc: 'Thanh toán học phí nhanh chóng, không phải xếp hàng chờ, không giới hạn không gian và thời gian',
  },
  {
    title: 'An toàn',
    img: require('@assets/icon/antoan.png'),
    desc: 'Có thể sử dụng thẻ ngân hàng của nhiều ngân hàng khác nhau và kiểm tra được tình trạng học phí',
  },
]

const TransactionHistory = () => {
  const { Get } = NetWorkService
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const params = useParams()

  const [isFalse, setIsFalse] = useState(false)
  const [valueSearch, setValueSearch] = useState('')
  const { listEdubillDetail, edubillDetail } = useSelector<RootState, Type_Initstate>((state) => state.app)
  const [dataAdsLeft, setDataAdsLeft] = useState<any[]>([])
  const [dataAdsRight, setDataAdsRight] = useState<any[]>([])

  const handleGetData = async (
    maSv: string,
    cccd: string,
    captcha?: { id: string; text: string },
  ): Promise<boolean> => {
    try {
      dispatch(setLoading(true))
      const res: any = await Get<ItemBillResponse>({
        url: `/api/organization/${params.orgCode}/school/${params.schoolCode}/secret/${maSv}/${
          edubillDetail?.isSearchCCCD ? cccd : 0
        }`,
        params: captcha ? { captchaId: captcha.id, captchaText: captcha.text } : undefined,
      })
      if (res && validResponse(res) && res.code === CODE_SUCCESS && res?.data.data.success !== false) {
        const response = res?.data.data
        navigate(
          `${detectEnvUat() ? '/uat' : ''}/organization/${params.orgCode}/school/${params.schoolCode}/student/${
            response.secretCode
          }`,
          {
            state: { maSv, cccd },
          },
        )
        setIsFalse(false)
        return true
      } else {
        setIsFalse(true)
        res && validResponse(res) ? message.error(res.data.data.message) : message.error('Thông tin tra cứu không đúng')
        Sentry.captureMessage('Thông tin tra cứu không đúng')
        return false
      }
    } catch (error) {
      setIsFalse(true)
      message.error('Có lỗi xảy ra')
      console.log(error)
      Sentry.captureException(error)
      return false
    } finally {
      dispatch(setLoading(false))
    }
  }

  const handleNavigate = async (
    maSv: string,
    cccd: string,
    captcha?: { id: string; text: string },
  ): Promise<boolean> => {
    setValueSearch(maSv)
    return handleGetData(maSv, cccd, captcha)
  }

  useEffect(() => {
    dispatch(setStudenInfor(undefined))
  }, [])

  useEffect(() => {
    if (listEdubillDetail.length !== 0 && !edubillDetail) {
      dispatch(
        setEduBillDetail(
          listEdubillDetail.find((e) => e.orgCode === params.orgCode && e.schoolCode === params.schoolCode),
        ),
      )
    }
  }, [listEdubillDetail, params.orgCode, params.schoolCode])

  const parentRef = useRef<HTMLDivElement>(null)
  const childRef = useRef<HTMLDivElement>(null)
  const [childHeight, setChildHeight] = useState(0)

  useEffect(() => {
    if (!childRef.current) return

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.contentRect) {
          setChildHeight(entry.contentRect.height)
        }
      }
    })

    observer.observe(childRef.current)

    return () => observer.disconnect()
  }, [])
  const getDataAds = async () => {
    try {
      const res: any = await Get<any>({
        url: `/api/organization/${params.orgCode}/school/${params.schoolCode}/ads-public`,
      })
      if (res && validResponse(res) && res.code === CODE_SUCCESS) {
        const response = res?.data.data
        console.log(response)
        const sidebarLeftItems = response.filter((item) => item.position === 'sidebar_left')
        const sidebarRightItems = response.filter((item) => item.position === 'sidebar_right')
        setDataAdsLeft(sidebarLeftItems)
        setDataAdsRight(sidebarRightItems)
      } else {
        res && validResponse(res) ? message.error(res.data.data.message) : message.error('Lấy dữ liệu quảng cáo lỗi')
        Sentry.captureMessage('Lấy dữ liệu quảng cáo lỗi')
      }
    } catch (error) {
      message.error('Có lỗi xảy ra')
      console.log(error)
      Sentry.captureException(error)
    } finally {
      dispatch(setLoading(false))
    }
  }
  useEffect(() => {
    getDataAds()
  }, [])

  const renderIntroduce = () => {
    return (
      <div className="mx-auto px-4 mt-8 md:mt-12">
        <div
          ref={parentRef}
          style={{ height: childHeight }}
          className="flex md:flex-row flex-col mx-auto max-w-[1200px] mt-2 sm:mt-10 md:min-h-[416px] min-h-[1416px] md:px-0 px-4"
        >
          <div
            ref={childRef}
            className="  flex-1  absolute left-0 bg-white  hidden 2xl:flex flex-col boxShadow-1 md:mx-3 items-center responsive-max-w-ads md:mt-0 mt-5 w-full  "
          >
            {dataAdsLeft?.map((e, i) => (
              <img
                key={i}
                src={`${API_URL}res/organization/cntn/school/cntn_uat/upload/preview/${e.image}`}
                alt=""
                className="mb-3 w-full "
              />
            ))}
          </div>
          {dataIntroduce.map((e, i) => (
            <div
              className="rounded-[16px] bg-white lg:pt-6 lg:px-5 pt-4 px-3 flex flex-col boxShadow-1 md:mx-3 items-center md:max-w-[290px] md:mt-0 mt-5 w-full h-[350px] sm:h-[400px]"
              key={i}
            >
              <div className="text-[#06163A] text-[22px] pb-2 sm:text-[30px] font-[600] sm:pb-4 border-b-2 border-[#045993]">
                {e.title}
              </div>
              <div className="pt-5">
                <img
                  src={e.img}
                  alt={e.title}
                  width={120}
                  height={120}
                  className="w-[120px] h-[120px] object-contain"
                />
              </div>
              <div
                className="pt-5 text-[16px] font-[300] text-center"
                style={{
                  color: 'rgba(83, 97, 108, 0.85)',
                }}
              >
                {e.desc}
              </div>
            </div>
          ))}
          <div
            ref={childRef}
            className="  flex-1  absolute right-0 bg-white  hidden 2xl:flex flex-col boxShadow-1 md:mx-3 items-center responsive-max-w-ads md:mt-0 mt-5 w-full  "
          >
            {dataAdsRight?.map((e, i) => (
              <img
                key={i}
                src={`${API_URL}res/organization/cntn/school/cntn_uat/upload/preview/${e.image}`}
                alt=""
                className="mb-3"
              />
            ))}
          </div>
        </div>
      </div>
    )
  }

  // bills.length === 0 && valueSearch
  return (
    <div className="relative">
      <Search handleGetBillList={handleNavigate} isHistory={true} />

      {!valueSearch && !isFalse && renderIntroduce()}
      <TableHistory isFalse={isFalse} valueSearch={valueSearch} />
    </div>
  )
}

export default TransactionHistory
